import FilterSection from "@SearchResults/features/sidebar/components/FilterSection";
import {SearchResultsRtkQueryResponseType} from "@SearchResults/api/types/SearchResultsRtkQueryResponse.type";
import Company from "@SearchResults/features/sidebar/features/companyFilters/components/Company";
import getUniqueCompaniesForActiveTab
    from "@SearchResults/features/sidebar/features/companyFilters/functions/getUniqueCompaniesForActiveTab";
import useActiveTabFromParams from "@SearchResults/hooks/useActiveTabFromParams";
import Column from "@Containers/components/Column";
import useFlixbusViaTravelierConnectExperiment
    from "@SearchResults/features/experiments/hooks/useFlixbusViaTravelierConnectExperiment";
import ParamsType from "@SearchResults/types/params/Params.type";

type CarrierFilterProps = {
    searchData: SearchResultsRtkQueryResponseType,
    params?: ParamsType
}

function CompanyFilter({searchData, params}: CarrierFilterProps) {
    const tab = useActiveTabFromParams()
    
    // Apply the same experiment filter logic that's used in usePrepareAndSortRoutes
    const {prepareRoutesForExperiment} = useFlixbusViaTravelierConnectExperiment(params as ParamsType)
    const rawRoutes = searchData.result.singleRoutes[tab]
    const filteredRoutes = params ? prepareRoutesForExperiment(rawRoutes) : rawRoutes
    
    const companies = getUniqueCompaniesForActiveTab({
        searchData,
        tab,
        filteredRoutes,  // Pass the filtered routes instead of using raw routes
    })

    if (companies.length < 2) {
        return null
    }

    return (
        <FilterSection
            filterDataKey="filterCompanies"
            isToggleable={companies.length > 10}
            translationKey="search_results.filter_by.companies.label"
        >
            <Column className="company-filter">
                {companies.map((company) => (
                    <Company
                        key={company.id}
                        company={company}
                    />
                ))}
            </Column>
        </FilterSection>
    );
}

export default CompanyFilter;